import { render, staticRenderFns } from "./MemoryGame.vue?vue&type=template&id=6883ac81&scoped=true&"
import script from "./MemoryGame.vue?vue&type=script&lang=js&"
export * from "./MemoryGame.vue?vue&type=script&lang=js&"
import style0 from "./MemoryGame.vue?vue&type=style&index=0&id=6883ac81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6883ac81",
  null
  
)

export default component.exports